/**
 * @generated SignedSource<<3293015a02b5f16615bf618f1952fb7b>>
 * @relayHash 7ce210075e14b14676537a4ebd644477
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7ce210075e14b14676537a4ebd644477

import { ConcreteRequest } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Ch_createReferralLetterInput = {
  allergies: ReadonlyArray<string>;
  careProviderCopyToIds: ReadonlyArray<string>;
  conditions: ReadonlyArray<string>;
  diagnosisCode: string;
  documentLanguage: Language;
  medicationIds: ReadonlyArray<string>;
  patientId: string;
  progressNoteId: string;
  reasoning?: string | null;
};
export type useChCreateReferralMutation$variables = {
  input: Ch_createReferralLetterInput;
};
export type useChCreateReferralMutation$data = {
  readonly ch_createReferralLetter: {
    readonly ch_ReferralLetter: {
      readonly allergies: ReadonlyArray<string> | null;
      readonly careProviderIds: ReadonlyArray<string> | null;
      readonly careProvidersCopyTo: ReadonlyArray<{
        readonly businessName: string | null;
        readonly city: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly postalCode: string | null;
        readonly streetAddress: string | null;
        readonly title: string | null;
      }>;
      readonly concludedAt: string | null;
      readonly concludedBy: string | null;
      readonly conditions: ReadonlyArray<string> | null;
      readonly createdAt: string;
      readonly createdBy: string;
      readonly documentLanguage: Language;
      readonly fileId: string | null;
      readonly fileMetadata: {
        readonly documentType: string;
        readonly extension: string;
        readonly lengthInKilobytes: number;
      } | null;
      readonly icdDiagnosis: {
        readonly associationType: AssociationType | null;
        readonly diagnosisCode: string;
        readonly id: string;
        readonly isAssociation: boolean;
        readonly primaryCode: string | null;
        readonly secondaryCode: string | null;
        readonly text: string;
      };
      readonly id: string;
      readonly medicationIds: ReadonlyArray<string> | null;
      readonly patientId: string;
      readonly progressNote: {
        readonly pointOfCare: {
          readonly careProvider: {
            readonly businessName: string | null;
            readonly city: string | null;
            readonly creditorCodeRegister: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly postalCode: string | null;
            readonly streetAddress: string | null;
            readonly title: string | null;
          } | null;
        } | null;
      };
      readonly progressNoteId: string;
      readonly reasoning: string | null;
      readonly referralId: number;
      readonly signedAt: string | null;
      readonly updatedAt: string | null;
      readonly updatedBy: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChCreateReferralMutation = {
  response: useChCreateReferralMutation$data;
  variables: useChCreateReferralMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referralId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressNoteId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "careProviderIds",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditorCodeRegister",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentFileMetadata",
  "kind": "LinkedField",
  "name": "fileMetadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lengthInKilobytes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reasoning",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedAt",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medicationIds",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conditions",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allergies",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "documentLanguage",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedAt",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedBy",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "IcdDiagnosis",
  "kind": "LinkedField",
  "name": "icdDiagnosis",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAssociation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnosisCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v31 = {
  "kind": "InlineFragment",
  "selections": (v30/*:: as any*/),
  "type": "PatientIdIsRequired",
  "abstractKey": null
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v30/*:: as any*/),
  "type": "DocumentAlreadyExists",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChCreateReferralMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createReferralLetterPayload",
        "kind": "LinkedField",
        "name": "ch_createReferralLetter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ReferralLetter",
            "kind": "LinkedField",
            "name": "ch_ReferralLetter",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_PointOfCare",
                    "kind": "LinkedField",
                    "name": "pointOfCare",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CareProvider",
                        "kind": "LinkedField",
                        "name": "careProvider",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          (v7/*:: as any*/),
                          (v8/*:: as any*/),
                          (v9/*:: as any*/),
                          (v10/*:: as any*/),
                          (v11/*:: as any*/),
                          (v12/*:: as any*/),
                          (v13/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProvider",
                "kind": "LinkedField",
                "name": "careProvidersCopyTo",
                "plural": true,
                "selections": [
                  (v9/*:: as any*/),
                  (v8/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v13/*:: as any*/),
                  (v12/*:: as any*/),
                  (v11/*:: as any*/)
                ],
                "storageKey": null
              },
              (v29/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v31/*:: as any*/),
              (v32/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChCreateReferralMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_createReferralLetterPayload",
        "kind": "LinkedField",
        "name": "ch_createReferralLetter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ReferralLetter",
            "kind": "LinkedField",
            "name": "ch_ReferralLetter",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_PointOfCare",
                    "kind": "LinkedField",
                    "name": "pointOfCare",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CareProvider",
                        "kind": "LinkedField",
                        "name": "careProvider",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          (v7/*:: as any*/),
                          (v8/*:: as any*/),
                          (v9/*:: as any*/),
                          (v10/*:: as any*/),
                          (v11/*:: as any*/),
                          (v12/*:: as any*/),
                          (v13/*:: as any*/),
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v25/*:: as any*/),
              (v26/*:: as any*/),
              (v27/*:: as any*/),
              (v28/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProvider",
                "kind": "LinkedField",
                "name": "careProvidersCopyTo",
                "plural": true,
                "selections": [
                  (v9/*:: as any*/),
                  (v8/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v13/*:: as any*/),
                  (v12/*:: as any*/),
                  (v11/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v29/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v31/*:: as any*/),
              (v32/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7ce210075e14b14676537a4ebd644477",
    "metadata": {},
    "name": "useChCreateReferralMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "218ab93232a782597f5e065575ac4161";

export default node;
